import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

// Tracks the user's OS/browser-level "reduce motion" preference so decorative
// animations (e.g. the mobile bottom-sheet slide) can be skipped for anyone
// who has signaled they don't want them. Updates live if the preference
// changes while the app is open (e.g. via OS settings).
function usePrefersReducedMotion() {
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(() => (
        typeof window !== 'undefined' && typeof window.matchMedia === 'function'
            ? window.matchMedia(QUERY).matches
            : false
    ));

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;

        const mediaQueryList = window.matchMedia(QUERY);
        const handleChange = (event) => setPrefersReducedMotion(event.matches);

        if (mediaQueryList.addEventListener) {
            mediaQueryList.addEventListener('change', handleChange);
            return () => mediaQueryList.removeEventListener('change', handleChange);
        }
        // Safari < 14 fallback
        mediaQueryList.addListener(handleChange);
        return () => mediaQueryList.removeListener(handleChange);
    }, []);

    return prefersReducedMotion;
}

export default usePrefersReducedMotion;
